import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementTemplateForm from "../components/AgreementTemplateForm/AgreementTemplateForm";

export default function CreateAgreementTemplate() {
	const { t } = useTranslation();
	const { organization } = useOutletContext();

	const navigate = useNavigate();
	const hasRight = useHasRight();

	if (!hasRight("agreements.create")) {
		return false;
	}

	return (
		<>
			<div style={{ marginBottom: 15 }}>
				<Header as="h2">{t("createAgreementTemplate", "Create agreement template")}</Header>
			</div>

			<AgreementTemplateForm
				organization={organization}
				afterSubmit={(ref) => navigate(`../templates/${ref.id}`)}
			/>
		</>
	);
}
